import { ReactElement } from 'react';
import { Box, Container, Paper, Stack, Typography, Link } from '@mui/material';
import WhatAbilityLogo from '@/assets/logo/what-ability-logo.png';
import { styled } from '@mui/system';
import { Outlet } from 'react-router-dom';

export const AuthMainLayout = (): ReactElement => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        minWidth: '100vw',
        bgcolor: '#33408e',
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'center',
      }}
    >
      <Container
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          height: '100vh',
          minWidth: 0,
          p: 0,
        }}
        disableGutters
      >
        <Box display="flex" justifyContent="center" mb={4} mt={4}>
          <img src={WhatAbilityLogo} alt="Logo" style={{ height: 60 }} />
        </Box>
        <Paper
          sx={{
            boxShadow: `0px 20px 40px rgba(0, 0, 0, 0.36),0px -20px 40px rgba(0, 0, 0, 0.36)`,
            borderTopLeftRadius: 32,
            borderTopRightRadius: 32,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            p: 4,
            pt: 2,
            pb: 6,
            mt: 0,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            mx: 'auto',
            backgroundColor: '#f8f9fb',
            width: '100%',
            maxWidth: 400,
            minHeight: 0,
            paddingBottom: 3,
          }}
        >
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center'}}>
            <Outlet />
          </Box>

          <Stack direction="row" spacing={2} justifyContent="center">
            <Link
              href="#"
              underline="hover"
              fontSize={13}
              color="text.primary"
              sx={{ fontSize: 10 }}
            >
              Terms & Condition
            </Link>
            <Link
              href="#"
              underline="hover"
              fontSize={13}
              color="text.primary"
              sx={{ fontSize: 10 }}
            >
              Privacy Policy
            </Link>
            <Link
              href="#"
              underline="hover"
              fontSize={13}
              color="text.primary"
              sx={{ fontSize: 10 }}
              textAlign={'start'}
            >
              FAQ
            </Link>
          </Stack>
          <Typography
            variant="caption"
            color="text.primary"
            sx={{
              fontSize: 10,
              mt: 1,
              textAlign: 'center',
              position: 'bottom',
            }}
          >
            <Link
              href="#"
              underline="hover"
              color="#33408e"
              sx={{ fontSize: 10, fontWeight: 500 }}
            >
              By signing up, you agree to What Ability’s
            </Link>{' '}
            Terms and <br /> Condition of Use, Privacy Policy and Mobile Terms.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};
